/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GuestRoomReadAttributesThumbnail } from './guest-room-read-attributes-thumbnail';
/**
 * 
 * @export
 * @interface HotelReadAttributes
 */
export interface HotelReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof HotelReadAttributes
     */
    rentalTypes?: Array<HotelReadAttributesRentalTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    shortUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    slug?: string;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    stars?: HotelReadAttributesStarsEnum;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof HotelReadAttributes
     */
    thumbnail: GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof HotelReadAttributes
     */
    logoPositive: GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof HotelReadAttributes
     */
    logoNegative: GuestRoomReadAttributesThumbnail;
    /**
     * This field is used to enable diagramming only for the hotel.
     * @type {boolean}
     * @memberof HotelReadAttributes
     */
    onlyDiagramming?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum HotelReadAttributesRentalTypesEnum {
    Accommodation = 'accommodation',
    Breakfast = 'breakfast',
    FullBoard = 'full-board',
    HalfBoard = 'half-board',
    AllInclusive = 'all-inclusive'
}
/**
    * @export
    * @enum {string}
    */
export enum HotelReadAttributesStarsEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5
}

